import { render, staticRenderFns } from "./Past.vue?vue&type=template&id=158dd316&scoped=true"
import script from "./Past.vue?vue&type=script&lang=js"
export * from "./Past.vue?vue&type=script&lang=js"
import style0 from "./Past.vue?vue&type=style&index=0&id=158dd316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158dd316",
  null
  
)

export default component.exports